import { Edit } from "@/components/icons_new";
import { useOrderDetailsContext } from "../context/OrderDetailsContext";

export default function OrderNotesSection() {
  const { order } = useOrderDetailsContext();

  if (!order) return null;

  const hasNotes = order.notes && order.notes.trim().length > 0;

  return (
    <div className="rounded-md border border-[#d2d2d2] bg-white p-4">
      <div className="mb-2 flex items-center justify-between">
        <span className="text-[17px] font-semibold text-[#333333]">Notes</span>
      </div>
      <p className={`text-sm font-medium ${hasNotes ? "text-[#333333]" : "text-[#9e9e9e]"}`}>
        {hasNotes ? order.notes : "No notes available."}
      </p>
    </div>
  );
}
